import { CardCore } from 'src/Pages/components/CardCore/CardCore'
import {
  ResponsiveContainer,
  CartesianGrid,
  AreaChart,
  Tooltip,
  XAxis,
  YAxis,
  Area,
} from "recharts";
import { CardBodyCore } from 'src/Pages/components/CardCore/Components/CardBodyCore';
import { FormatMoney } from 'src/shared/Utils/FormatMoney';
import { alpha, Typography } from '@mui/material';
import { FormGraphicProduction } from './Form';
import { useMetricsContext } from 'src/Contexts/Metrics/ContextMetrics';

function formatNumberToShort(value: string): string {
  // remove pontos e troca vírgula por ponto para converter para número
  const number = parseFloat(value.replace(/\./g, '').replace(',', '.'))

  if (isNaN(number)) return value // retorna o valor original se não for número

  if (number >= 1_000_000_000) {
    return (number / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B'
  }
  if (number >= 1_000_000) {
    return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'
  }
  if (number >= 1_000) {
    return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'k'
  }

  return number.toString()
}

interface TooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: {
      label: string;
      value: number;
    };
  }>;
  labelStyle?: React.CSSProperties;
}

const CustomTooltip: React.FC<TooltipProps> = ({
  active,
  payload,
}) => {
  if (!active || !payload || payload.length === 0) { return null; }

  const data = payload[0].payload;

  const name = data.label;
  const value = data.value;

  return (
    <CardCore>
      <Typography style={{ fontSize: "1rem", fontWeight: "bold" }}>
        {name}
      </Typography>

      <Typography style={{ fontSize: "0.9rem", color: "text.secondary" }}>
        {`R$ ${FormatMoney((value ?? 0).toFixed(2))}`}
      </Typography>
    </CardCore>
  );
};

export const GraphicProduction = () => {
  const { dataGraphicProduction } = useMetricsContext();

  const colorStroke = "#b8b8b8";

  return (
    <CardCore sxStyle={{ margin: "0" }}>
      <CardBodyCore
        actions={[<FormGraphicProduction key={1} />]}
        title="Produção de contratos"
      >
        <ResponsiveContainer height={350} width="100%" >
          <AreaChart data={dataGraphicProduction.data} margin={{ left: -20 }}>
            <defs>
              <linearGradient id="colorPv" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0" stopColor="#3D5AFE" stopOpacity="0.3" />
                <stop offset="1" stopColor="#3D5AFE" stopOpacity="0.1" />
              </linearGradient>
            </defs>

            <XAxis dataKey="label" fontSize={14} stroke={colorStroke} />

            <YAxis
              fontSize={12}
              stroke={colorStroke}
              tickFormatter={(value) => formatNumberToShort(String(value))}
              tickLine={false}
            />

            <CartesianGrid
              horizontal
              stroke={alpha(colorStroke, 0.3)}
              vertical={false}
            />

            <Tooltip content={<CustomTooltip />} />

            <Area
              baseValue={0}
              dataKey="value"
              fill="url(#colorPv)"
              name="Produção"
              stroke="#6077FCFF"
              strokeWidth={2}
              type="bump"
            />
          </AreaChart>
        </ResponsiveContainer>
      </CardBodyCore>
    </CardCore>
  )
}